//加载汉子package
import Tools from '@hanzi-package/tools';
import Promise from 'bluebird';
import baseKeyboard from 'components/Keyboard.vue';
import { Alert, Log, Route } from 'hanzi-mobile-package';
import $ from 'jquery';
//弹出框类
import { Indicator, MessageBox, Toast } from 'mint-ui';
// import '../static/layim/dist/css/layui.mobile.css';
//underscore
import _ from 'underscore';
import Vue from 'vue';
import VueRouter from 'vue-router';
//vue-ydui
import 'vue-ydui/dist/ydui.base.css';
import Config from '../.config.js';
import App from './App';
// import '../static/navigation.js';
import './assets/sass/common/base.scss';
import comApp from './common/app';
//普通用户不能进入的加盟商页面
import Lv0CantPath from './common/dealerCantPath';
import LoginStatus from './common/loginStatus';
//加载错误操作设置
import ErrorData from './error_handle.js';
//加载本地路由
import BaseRoute from './routes/base';
import DynamicRoute from './routes/dynamic';
import ExampleRoute from './routes/example';
//不需要登录的页面
import NologinRoute from './routes/nologin';
import SystemRoute from './routes/system';





Vue.component(baseKeyboard.name,baseKeyboard);
Vue.filter('date', (date) => {
    let d = new Date(date*1000)
    let batchDate = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日'
    return batchDate
})
  
Vue.filter('money', (money) => {
    return money/100
})



MessageBox.confirm = function(message, title, options) {
    if (typeof title === 'object') {
      options = title;
      title = '';
    }
    return MessageBox(Object.assign({
      title: title || (tools.cache.get('is_vietnam')? 'Nhắc nhở' : '提示'),
      message: message,
      $type: 'confirm',
      showCancelButton: true,
      confirmButtonText: tools.cache.get('is_vietnam')? 'Xác nhận' : '确定',
      cancelButtonText: tools.cache.get('is_vietnam')? 'Hủy' : '取消',
    }, options));
};
MessageBox.alert = function(message, title, options) {
    if (typeof title === 'object') {
      options = title;
      title = '';
    }
    return MessageBox(Object.assign({
      title: title || (tools.cache.get('is_vietnam')? 'Nhắc nhở' : '提示'),
      message: message,
      $type: 'alert',
      closeOnPressEscape: false,
      closeOnClickModal: false,
      confirmButtonText: tools.cache.get('is_vietnam')? 'Xác nhận' : '确定',
      cancelButtonText: tools.cache.get('is_vietnam')? 'Hủy' : '取消',
    }, options));
};

var messageBox = MessageBox;
var toast = Toast;
var indicator = Indicator;
Alert.ui.messageBox = messageBox;
Alert.ui.toast = toast;
Alert.ui.indicator = indicator;



var tools = Tools;
var log = Log;
var alert = Alert;
var loginStatus = LoginStatus;

//定义错误操作数组
tools.errorData = ErrorData.data;
tools.loginStatus = loginStatus;

//underscore
tools._ = _;

//初始化路由
Route.data.baseRoute = BaseRoute;
Route.data.dynamicRoute = DynamicRoute;
Route.data.systemRoute = SystemRoute;
Route.data.exampleRoute = ExampleRoute;

var app = window;

Tools.vue = Vue;
Tools.alert = alert;

app.tools = tools;
app.config = Config;
app.log = log;
app.Promise = Promise;
app.app = comApp;

Vue.use(VueRouter);

/* 定义路由 */
const routes = Route.routes();
const router = new VueRouter({
    mode: 'history',
    routes
});
//记录刚进页面时的链接，ios用到
tools.cache.set('initUrl', location.href);
if(/(^\/distribution\/(chat))/.test(location.pathname)){
    window.wx = null;
    $('#weixin').remove();
    tools.cache.set('Authorization', tools.url.params('token'));
    // window.localStorage.Authorization = tools.url.params('token');
    // console.log('window.localStorage.Authorization : ' + window.localStorage.Authorization);
}

/* 初次打开,检查权限 */
router.beforeEach((to, from, next) => {

    // next();
    // debugger
    // if(to.path.indexOf('/login') > -1 && !tools.cache.get('is_wechat_login')){
    //     next();
    // }else{
    //     LoginStatus.check({
    //         type: 'login', // wechatOauth, login
    //         redirectUrl: '/login', //验证不通过跳转的地址
    //         url: to.path, //需要验证的地址
    //         callbackUrl: to.fullPath //返回的地址
    //     }, next);
    // }

    // console.log(to.path);
    // 停机维护
    // if (to.path.indexOf('update')<0) {
    //     tools.router.push({
    //         path: '/update', 
    //         query:{}
    //     })
    // }
    // next();
    // return;

    // return false;
    // console.log(to,tools.cache.get('is_vietnam'),/^\/vietnam/i.test(to.path));
    let is_vietnam = tools.cache.get('is_vietnam');
    if (is_vietnam && !(/\/vietnam/i.test(to.path))) {
        tools.router.replace({
            path: '/vietnam'+to.path,
            query:{}
        })
        next();
    }
    else if(!is_vietnam && (/\/vietnam/i.test(to.path))){
        tools.router.replace({
            path: to.path.replace(/\/vietnam/i,''),
            query:{}
        })
        // next();
    }
    if(to.path=='/register'){

        // var firstcome = tools.cache.get('firstcome');
        // if(firstcome){
        //     tools.cache.set('Authorization', '');
        //     window.localStorage.Authorization = '';
        //     tools.cache.set('firstcome', 0);
        // }
        // if(localStorage.Authorization){
        // }
            LoginStatus.checkLogin({
                type: 'login', // wechatOauth, login
                redirectUrl: '/login', //验证不通过跳转的地址
                url: to.path, //需要验证的地址
                callbackUrl: to.fullPath //返回的地址
            }, next);
    }
    // && !tools.cache.get('is_wechat_login')
    // else if(to.path=='/login'){
        
    //     if (!tools.cache.get('noFirst')) {
    //         var obj = to.query.callback?{callback:decodeURIComponent(to.query.callback)}:{};
    //         tools.router.push({path: '/bind_wechat', query: obj});
    //         return;
    //     }else{
    //         next();
    //     }
    // }
    else{
        // if(localStorage.Authorization){
        //     tools.cache.set('Authorization', localStorage.Authorization);
        // }
        LoginStatus.checkLogin({
            type: 'login', // wechatOauth, login
            // redirectUrl: '/api/wechat/auth', //验证不通过跳转的地址
            redirectUrl: '/login', //验证不通过跳转的地址
            url: to.path, //需要验证的地址
            callbackUrl: to.fullPath //返回的地址
        }, next);
    }
});


/* 定义路由示例 */
app.tools.router = router;

/* 定义路由数组 */
app.tools.routes = routes;

//定义是否可以初始化签名
app.canauthinit = 1;

//不需要登录的页面
tools.noLoginUrl = NologinRoute;

//普通用户不能进入的加盟商页面
tools.lv0CantPath = Lv0CantPath;

// 定义指令
const windowHeight = window.innerHeight
Vue.directive('fixedInput', function (el, binding) {
    el.addEventListener('blur', function () {
        let windowFocusHeight = window.innerHeight
        if (windowHeight == windowFocusHeight) {
            return
        }
        let currentPosition;
        let speed = 1; //页面滚动距离
        currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
        setTimeout(() => {
            currentPosition -= speed;
            window.scrollTo(0, currentPosition); //页面向上滚动
            currentPosition += speed; //speed变量
            window.scrollTo(0, currentPosition); //页面向下滚动
        }, 10);
    })
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    template: '<App/>',
    components: { App },
    router
});


// WEBPACK FOOTER //
// ./src/main.js